module.exports = __webpack_public_path__ + "img/icon_wechat.e97b2fb1.png";